import Vue from "vue";

const queryString = window.location.search;
const params = new URLSearchParams(queryString);
const m = params.get("m");
Vue.prototype.$returnColor = function returnColor() {
  if (
    document.domain == process.env.VUE_APP_TYH ||
    document.domain == "43.138.153.196" ||
    document.domain == "47.243.93.168" ||
    document.domain == "47.239.136.97" ||
    document.domain == "store.rzxl923.com" ||
    document.domain == "ht.hdsaj.com"
  ) {
    return {
      path: "blue",
      color1: "#81c7e8",
      color2: "#679dd4",
      color3: "#055d9b",
    };
  } else if (
    document.domain == process.env.VUE_APP_LEEJIA ||
    document.domain == "store.niks882.com"
  ) {
    return {
      path: "leejia",
      color1: "#D4B5D2",
      color2: "#7F4568",
      color3: "#423345",
    };
  } else if (
    (document.domain == "47.242.225.81" ||
      document.domain == "47.83.129.213") &&
    ((m && m == "hw") || localStorage.getItem("mI") == "hw")
  ) {
    return {
      path: "hw",
      color1: "#DCC4D8",
      color2: "#DCC4D8",
      color3: "#DCC4D8",
      color4: "#DCC4D8",
    };
  } else if (
    document.domain == process.env.VUE_APP_PPP ||
    document.domain == "119.91.195.29" ||
    document.domain == process.env.VUE_APP_CROWN ||
    document.domain == process.env.VUE_APP_ZHAOFU ||
    document.domain == "store.kxzi342.com" ||
    document.domain == "119.28.31.200" ||
    document.domain == "129.226.121.148" ||
    document.domain == "store.rxjh382.com" ||
    window.location.port == 82 ||
    document.domain == "43.139.102.188" ||
    document.domain == "store.hspf115.com" ||
    document.domain == "store.xoazww.com" ||
    document.domain == "store.soax0z.com" ||
    document.domain == "119.91.48.139" ||
    document.domain == "101.33.250.39" ||
    document.domain == "42.193.130.202" ||
    document.domain == "47.242.177.16" ||
    document.domain == "150.109.117.219" ||
    document.domain == "47.76.29.193" ||
    document.domain == "47.238.137.188" ||
    document.domain == "47.238.111.137" ||
    document.domain == "47.83.129.213" ||
    document.domain == "47.83.168.207" ||
    document.domain == "47.242.225.81" ||
    document.domain == "47.83.129.213" ||
    document.domain == "47.239.153.189" ||
    document.domain == "47.239.98.118" ||
    document.domain == "47.242.41.206" ||
    document.domain == "8.210.76.250" ||
    document.domain == "119.28.73.52" ||
    document.domain == "47.83.153.10" ||
    document.domain.indexOf("kxzi342") != -1 ||
    document.domain == "b.hdsaj.com"
  ) {
    return {
      path: "greenblue",
      color1: "#a9d297",
      color2: "#00c7aa",
      color3: "#009aaa",
      color4: "rgb(123 214 216)",
    };
  } else if (
    document.domain == "store.olzde8213.com" ||
    document.domain == "42.194.148.159" ||
    document.domain == "47.239.88.174" ||
    document.domain == "47.239.169.10"
  ) {
    return {
      path: "redblack",
      color1: "#ffb1b1",
      color2: "#00c7aa",
      color3: "#009aaa",
      color4: "#ffb1b1",
    };
  } else if (
    document.domain == "running.etmart2.test" ||
    document.domain == "43.155.13.226" ||
    document.domain == "43.129.64.215" ||
    document.domain == "150.109.61.55" ||
    document.domain == "101.32.177.157" ||
    document.domain == "store.lxiadc12.com"
  ) {
    return {
      path: "hw",
      color1: "#DCC4D8",
      color2: "#DCC4D8",
      color3: "#DCC4D8",
      color4: "#DCC4D8",
    };
  } else {
    return {
      path: "",
      color1: "#a9d297",
      color2: "#00c7aa",
      color3: "#009aaa",
      color4: "#a9d297",
    };
  }
};
